'use strict';

const libPictView = require('pict-view');

/**
 * RecordDates — the standalone container for the Project/Contract important-dates editor. All logic/state live in the
 * RecordDates provider, which renders hand-built HTML into #RecordDates-Host (the route handler calls openAsync after
 * this view mounts). The same provider also renders into a workspace tab host via openInto().
 */
class RecordDates extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.RecordDates; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider && (this.pict.AppData.RecordDates)) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = RecordDates;
module.exports.default_configuration =
{
	ViewIdentifier: 'RecordDates',
	DefaultRenderable: 'RecordDatesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.rd-wrap { padding: 1.1rem 1.25rem 1.5rem; max-width: 52rem; }
		.rd-head { margin: 0 0 1.1rem; border-bottom: 1px solid var(--theme-color-border-light,#eef1f6); padding-bottom: 0.7rem; }
		.rd-eyebrow { font-size:0.68rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#8894a4); }
		.rd-title { font-size:1.3rem; font-weight:700; line-height:1.2; color:var(--theme-color-text-primary,#1f2733); margin-top:0.15rem; }
		.rd-sub { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin-top:0.15rem; }
		.rd-section { margin: 0 0 1.2rem; }
		.rd-section-head { font-size:0.7rem; font-weight:800; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-secondary,#45505f); margin:0 0 0.5rem; }
		.rd-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.6rem; }
		.rd-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); }
		.rd-row { display:flex; align-items:center; flex-wrap:wrap; gap:0.6rem; padding:0.35rem 0; border-bottom:1px solid var(--theme-color-border-light,#f0f2f6); }
		.rd-row-name { flex:1 1 15rem; min-width:0; font-size:0.9rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); display:flex; align-items:center; gap:0.4rem; }
		.rd-row-nameinput { flex:1 1 12rem; min-width:0; font-size:0.88rem; font-weight:600; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.rd-row-code { flex:0 0 7rem; font-size:0.82rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-secondary,#45505f); background:var(--theme-color-background-input,#fff); }
		.rd-date { flex:0 0 auto; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; color:var(--theme-color-text-primary,#1f2733); background:var(--theme-color-background-input,#fff); }
		.rd-date-disp { flex:0 0 auto; font-size:0.86rem; color:var(--theme-color-text-primary,#1f2733); min-width:6.5rem; }
		.rd-muted { color:var(--theme-color-text-muted,#8894a4); }
		.rd-new-name { flex:1 1 12rem; min-width:0; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
		.rd-new-code { flex:0 0 8rem; font-size:0.86rem; padding:0.3rem 0.5rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; }
		.rd-code { font-size:0.66rem; font-weight:700; letter-spacing:0.02em; padding:0.06rem 0.4rem; border-radius:9px; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-tertiary,#e2e7ef); }
		.rd-chip { font-size:0.6rem; font-weight:700; text-transform:uppercase; letter-spacing:0.03em; padding:0.06rem 0.4rem; border-radius:9px; }
		.rd-chip-set { color:#276749; background:#e6f4ea; }
		.rd-chip-missing { color:#6b7686; background:#eef1f6; }
		.rd-chip-adhoc { color:#8a6d1b; background:#fbf3d9; }
		.rd-btn { font-size:0.8rem; font-weight:600; padding:0.32rem 0.7rem; border-radius:6px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-primary,#1f2733); cursor:pointer; }
		.rd-btn-sm { padding:0.24rem 0.55rem; font-size:0.78rem; }
		.rd-btn-primary { color:#fff; background:var(--theme-color-primary,#2f6fed); border-color:var(--theme-color-primary,#2f6fed); }
		.rd-btn-danger { color:#fff; background:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.rd-icon { border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); border-radius:5px; cursor:pointer; font-size:0.8rem; line-height:1; padding:0.24rem 0.45rem; color:var(--theme-color-text-secondary,#45505f); }
		.rd-icon-x:hover { color:var(--theme-color-status-danger,#c0392b); }
		.rd-confirm { font-size:0.8rem; color:var(--theme-color-text-secondary,#45505f); display:inline-flex; align-items:center; gap:0.3rem; }
		.rd-row-err { font-size:0.78rem; color:var(--theme-color-status-danger,#c0392b); }
		.rd-sched-opts { display:flex; align-items:center; gap:1.2rem; flex-wrap:wrap; }
		.rd-radio { font-size:0.88rem; color:var(--theme-color-text-primary,#1f2733); display:inline-flex; align-items:center; gap:0.4rem; }
		.rd-sched-notice { font-size:0.78rem; color:#276749; }
		.rd-section-contract { margin-top:1.4rem; padding-top:1rem; border-top:1px dashed var(--theme-color-border-medium,#d5dbe3); }
		.rd-sub-inline { font-size:0.68rem; font-weight:600; text-transform:none; letter-spacing:0; color:var(--theme-color-text-muted,#8894a4); margin-left:0.35rem; }
		.rd-sub-inline a { color:var(--theme-color-primary,#2f6fed); }
		.rd-row-readonly { opacity:0.95; }
		.rd-chip-src-project { color:#1f5fbf; background:#e7eefb; }
		.rd-chip-src-contract { color:#6b3fa0; background:#efe8f7; }
	`,
	Templates:
	[
		{
			Hash: 'RecordDates-Wrap',
			Template: /*html*/`<div id="RecordDates-Host"></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'RecordDatesWrap',
			TemplateHash: 'RecordDates-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
